import { SendBtnComponent } from '@web-components/buttons/send-btn/send-btn';
import { EditBtnComponent } from '@web-components/buttons/edit-btn/edit-btn';
import { SettingsBtnComponent } from '@web-components/buttons/settings-btn/settings-btn';
import { SnWarningComponent } from '@components/common/sn-warning/sn-warning';
import { DeleteBtnComponent } from '@web-components/buttons/delete-btn/delete-btn';
import { ClientCardComponent } from '@web-components/client/client-card/client-card';
import { EnableClientsOptInComponent } from '@web-components/client/enable-clients-opt-in/enable-clients-opt-in';
import { JobClientComponent } from '@web-components/client/job-client/job-client';
import { SaveOptinConsentModalComponent } from '@components/base/client/modals/save-optin-consent-modal/save-optin-consent-modal';
import { InvoiceUpdateDnd } from '@web-components/invoices/invoice-update/invoice-update-dnd/invoice-update-dnd';
import { QuoteClientInfoComponent } from '@web-components/quotes/common/quote-client-info/quote-client-info';
import { QuoteCreatePackageComponent } from '@web-components/quotes/common/quote-create-package-block/quote-create-package-block';
import { QuoteJobInfoComponent } from '@web-components/quotes/common/quote-job-info/quote-job-info';
import { QuoteUpdateComponent } from '@web-components/quotes/quote-update/quote-update';
import { PaymentScheduleComponent } from '@web-components/quotes/common/payment-schedule/payment-schedule';
import { QuoteContractAndQuestionComponent } from '@web-components/quotes/common/quote-contract-and-question/quote-contract-and-question';
import { QuoteSummaryBlockComponent } from '@web-components/quotes/common/quote-summary-block/quote-summary-block';
import { EnableGdprSectionComponent } from '@web-components/settings/gdpr/enable-gdpr-section/enable-gdpr-section';
import { ContractSignatureComponent } from '@web-components/contract/contract-signature/contract-signature';
import { CloseBtnComponent } from '@components/common/buttons/close-btn/close-btn';
import { SnLabelComponent } from '@components/common/sn-label/sn-label';
import { OptInAgreementComponent } from '@components/common/opt-in-agreement/opt-in-agreement';
import { SubscribeClientBtnComponent } from '@web-components/buttons/subscribe-client-btn/subscribe-client-btn';
import { ClientPhotoWebComponent } from '@web-components/client/client-photo/client-photo';
import { ClientSubscribeInfoWebComponent } from '@web-components/client/client-subscribe-info/client-subscribe-info';
import { ResubscribeClientModalWebComponent } from '@web-components/client/modals/resubscribe-client-modal/resubscribe-client-modal';
import { UploadPhotoModalWebComponent } from '@web-components/client/modals/upload-photo-modal/upload-photo-modal';
import { QuestionnaireSubmittedStatementComponent } from '@components/common/questionnaire-submitted-statement/questionnaire-submitted-statement';
import { TermsUpdatedModalComponent } from '@web-components/common/terms-updated-modal/terms-updated-modal';
import { WorkflowExitModalComponent } from '@web-components/settings/workflow-exit-modal/workflow-exit-modal';
import { WarningSignImgComponent } from '@components/common/warning-sign-img/warning-sign-img';
import { SearchbarComponent } from '@web-components/common/searchbar/searchbar';
import { SnPaginationComponent } from '@web-components/common/sn-pagination/sn-pagination';
import { ConsentListWebComponent } from '@web-components/client/consent-list/consent-list';
import { ArchiveBtnComponent } from '@components/common/buttons/archive-btn/archive-btn';
import { SnTinyEditorComponent } from '@mob-components/shared/sn-tiny-editor/sn-tiny-editor';
import { CancelBtnComponent } from '@mob-components/buttons/cancel-btn/cancel-btn';
import { ErrorMessageModalWebComponent } from '@web-components/common/error-message-modal/error-message-modal';
import { AutocompleteEmailInputComponent } from '@web-components/inputs/autocomplete-email-input/autocompete-email-input';
import { AttachmentsComponent } from '@mob-components/files/attachments/attachments';
import { TrialModalWebComponent } from '@web-components/subscription/modals/trial-modal/trial-modal';
import { SubscriptionBannerListWebComponent } from '@web-components/subscription/subscription-elements/subscription-banner-list/subscription-banner-list';
import { SubscriptionAnnualDiscountWebComponent } from '@web-components/subscription/subscription-elements/subscription-annual-discount/subscription-annual-discount';
import { SubscriptionAnnualWebComponent } from '@web-components/subscription/subscription-elements/subscription-annual/subscription-annual';
import { SubscriptionMonthlyDiscountWebComponent } from '@web-components/subscription/subscription-elements/subscription-monthly-discount/subscription-monthly-discount';
import { SubscriptionMonthlyWebComponent } from '@web-components/subscription/subscription-elements/subscription-monthly/subscription-monthly';
import { EventTypeRowComponent } from '@web-components/common/event-type-row/event-type-row';
import { AddRoundBtnComponent } from '@web-components/buttons/add-round-btn/add-round-btn';
import { SimplePaginationComponent } from '@web-components/buttons/simple-pagination/simple-pagination';
import { ShootsAppointmentsBlockComponent } from '@web-components/dashboard/shoots-appointments-block/shoots-appointments-block';
import { RecentLeadsBlockComponent } from '@web-components/dashboard/recent-leads-block/recent-leads-block';
import { DeleteLeadModalComponent } from '@web-components/leads/delete-lead-modal/delete-lead-modal';
import { UserMenuComponent } from '@web-components/user-menu/user-menu';
import { DragAndDropBlockComponent } from '@web-components/dashboard/drag-and-drop-block/drag-and-drop-block';
import { GraphsBlockComponent } from '@web-components/dashboard/graphs-block/graphs-block';
import { UpcomingPaymentsBlockComponent } from '@web-components/dashboard/upcoming-payments-block/upcoming-payments-block';
import { RecordPaymentModalComponent } from '@web-components/payments/modals/record-payment-modal/record-payment-modal';
import { WriteOffModalComponent } from '@web-components/payments/modals/write-off-modal/write-off-modal';
import { JobTaskBlockComponent } from '@web-components/dashboard/job-task-block/job-task-block';
import { DeleteJobModalComponent } from '@web-components/jobs/delete-job-modal/delete-job-modal';
import { SnDateRangePickerComponent } from '@web-components/common/sn-date-range-picker/sn-date-range-picker.component';
import { UploadComponent } from '@web-components/common/upload-component/upload-component';
import { SnDatePickerComponent } from '@web-components/common/sn-date-picker/sn-date-picker.component';
import { PackageInfoPanelComponent } from '@web-components/quotes/package-info-panel/package-info-panel.component';
import { PriceTagComponent } from '@web-components/price-tag/price-tag.component';
import { SnTinyEditorWebComponent } from '@web-components/common/sn-tiny-editor/sn-tiny-editor';
import { JobFilesModalComponent } from '@web-components/common/sn-tiny-editor/job-files-modal/job-files-modal.component';
import { MainShootDateComponent } from '@components/common/main-shoot-date/main-shoot-date';
import { QuoteViewComponent } from '@web-components/quote/quote-view/quote-view';
import { PrintBtnComponent } from '@web-components/buttons/print-btn/print-btn';
import { ModalDeleteQuoteComponent } from '@web-components/quote/modals/modal-delete-quote/modal-delete-quote';
import { QuoteInfoComponent } from '@web-components/quote/common/quote-info/quote-info';
import { QuoteFromInfoComponent } from '@web-components/quote/common/quote-from-info/quote-from-info';
import { ModalSendQuoteComponent } from '@web-components/quote/modals/modal-send-quote/modal-send-quote';
import { PackagesProductBlockComponent } from '@web-components/packages-product/packages-product-block/product-packages-block.component';
import { PackagesBlockComponent } from '@web-components/packages-product/packages-block/packages-block.component';
import { ProductBlockComponent } from '@web-components/packages-product/product-block/product-block.component';
import { UpdatePackageProductModalComponent } from '@web-components/packages-product/modals/update-package-product-modal/update-package-product-modal.component';
import { AddonsTableComponent } from '@web-components/quotes/addons-table/addons-table.component';
import { ProductDetailsModalComponent } from '@web-components/quotes/modals/product-details-modal/product-details-modal.component';
import { AddNewElementBtnComponent } from '@web-components/buttons/add-new-element-btn/add-new-element-btn.component';
import { AddQuoteTypeModalComponent } from '@web-components/quotes/modals/add-quote-type-modal/add-quote-type-modal.component';
import { QuoteViewFixedComponent } from '@web-components/quote/quote-view-fixed/quote-view-fixed';
import { ProductPackageTableComponent } from '@web-components/quotes/product-package-table/product-package-table';
import { QuoteAssignmentPanelComponent } from '@web-components/quote/quote-assignment-panel/quote-assignment-panel.component';
import { ReSyncBtnComponent } from '@components/common/buttons/re-sync-btn/re-sync-btn';
import { InvoiceViewComponent } from '@web-components/invoices/invoice-view/invoice-view';
import { InvoiceInfoTableComponent } from '@web-components/invoices/invoice-view/invoice-info-table/invoice-info-table';
import { InvoicePaymentsScheduleTable } from '@web-components/invoices/invoice-view/invoice-payments-schedule-table/invoice-payments-schedule-table';
import { ModalMakeInvoiceComponent } from '@web-components/quote/modals/modal-make-invoice/modal-make-invoice';
import { SnQuillViewComponent } from '@components/common/sn-quill-view/sn-quill-view';
import { ShowMoreContentComponent } from '@web-components/common/show-more-content/show-more-content.component';
import { DiscountCreateBlockComponent } from '@web-components/quotes/common/discount-create-block/discount-create-block.component';
import { DiscountViewBlockComponent } from '@web-components/quotes/common/discount-view-block/discount-view-block.component';
import { MarkQuoteAsAcceptedModal } from '@web-components/quote/modals/mark-quote-as-accepted/mark-quote-as-accepted.modal';
import { PreviewBtnComponent } from '@web-components/buttons/preview-btn/preview-btn';
import { CopyToXeroBtnComponent } from '@web-components/buttons/copy-to-xero-btn/copy-to-xero-btn';
import { CopyToQbBtnComponent } from '@web-components/buttons/copy-to-qb-btn/copy-to-qb-btn';
import { DeleteInvoiceModalComponent } from '@web-components/invoices/modals/delete-invoice-modal/delete-invoice-modal';
import { InvoicePaymentActionButtons } from '@web-components/invoices/invoice-view/invoice-payments-action-buttons/invoice-payment-action-buttons';
import { SavePdfBtnComponent } from '@web-components/buttons/save-pdf-btn/save-pdf-btn';
import { InvoiceClientInfoComponent } from '@web-components/invoices/invoice-update/invoice-client-info/invoice-client-info';
import { InvoiceContractQuestionComponent } from '@web-components/invoices/invoice-update/invoice-contract-question/invoice-contract-question';
import { InvoiceJobInfoComponent } from '@web-components/invoices/invoice-update/invoice-job-info/invoice-job-info';
import { InvoiceMainInfoComponent } from '@web-components/invoices/invoice-update/invoice-main-info/invoice-main-info';
import { InvoicePaymentScheduleComponent } from '@web-components/invoices/invoice-update/invoice-payment-schedule/invoice-payment-schedule';
import { InvoiceSummaryComponent } from '@web-components/invoices/invoice-update/invoice-summary/invoice-summary';
import { InvoiceUpdateComponent } from '@web-components/invoices/invoice-update/invoice-update';
import { ShootProofViewBlockComponent } from '@web-components/integrations/shootProof/shootProof-view-block/shootProof-view-block.component';
import { ShootProofDeleteGalleryModal } from '@web-components/integrations/shootProof/modals/shootProof-delete-gallery-modal/shootProof-delete-gallery.modal';
import { AddShootProofGalleryModal } from '@web-components/integrations/shootProof/modals/add-shootProof-gallery-modal/add-shootProof-gallery.modal';
import { CreateNewShootProofGalleryModal } from '@web-components/integrations/shootProof/modals/create-new-shootProof-gallery-modal/create-new-shootProof-gallery.modal';
import { SelectExistingShootProofGalleryModal } from '@web-components/integrations/shootProof/modals/select-existing-shootProof-gallery-modal/select-existing-shootProof-gallery.modal';
import { DeleteConfirmationModal } from '@web-components/integrations/shootProof/modals/delete-confirmation-modal/delete-confirmation.modal.';
import { InvoicesViewBlockComponent } from '@web-components/invoices/invoices-view-block/invoices-view-block.component';
import { ShootproofInvoicesBlockComponent } from '@web-components/invoices/shootproof-invoices-block/shootproof-invoices-block.component';
import { CopyInvoiceToQuickBooksModal } from '@web-components/invoices/modals/copy-invoice-to-quickBooks/copy-invoice-to-quickBooks.modal';
import { PaymentsOverviewComponent } from '@web-components/payments/payments-overview/payments-overview.component';
import { BtnSubscriptionComponent } from '@web-components/buttons/btn-subscription/btn-subscription';
import { ContactFormSectionComponent } from '@web-components/settings/contact-form-section/contact-form-section';
import { TemplateListComponent } from '@web-components/settings/common/template-list/template-list';
import { SettingSectionHeaderComponent } from '@web-components/settings/common/setting-section-header/setting-section-header';
import { SettingSectionDescriptionComponent } from '@web-components/settings/common/setting-section-description/setting-section-description';
import { SettingsAddBtnComponent } from '@web-components/buttons/settings-add-btn/settings-add-btn';
import { DeleteItemModalComponent } from '@web-components/settings/common/delete-item-modal/delete-item-modal';

export const downgradedComponents = [
	SnLabelComponent,
	SnWarningComponent,
	SettingsBtnComponent,
	ResubscribeClientModalWebComponent,
	TermsUpdatedModalComponent,
	SaveOptinConsentModalComponent,
	BtnSubscriptionComponent,
	JobClientComponent,
	SendBtnComponent,
	EditBtnComponent,
	EnableGdprSectionComponent,
	UploadPhotoModalWebComponent,
	CloseBtnComponent,
	ClientCardComponent,
	DeleteBtnComponent,
	SubscribeClientBtnComponent,
	OptInAgreementComponent,
	ContractSignatureComponent,
	QuestionnaireSubmittedStatementComponent,
	EnableClientsOptInComponent,
	ClientPhotoWebComponent,
	ClientSubscribeInfoWebComponent,
	WorkflowExitModalComponent,
	WarningSignImgComponent,
	WorkflowExitModalComponent,
	SearchbarComponent,
	SnPaginationComponent,
	WorkflowExitModalComponent,
	ConsentListWebComponent,
	ArchiveBtnComponent,
	SnTinyEditorComponent,
	CancelBtnComponent,
	ErrorMessageModalWebComponent,
	AttachmentsComponent,
	TrialModalWebComponent,
	SubscriptionBannerListWebComponent,
	SubscriptionAnnualDiscountWebComponent,
	SubscriptionAnnualWebComponent,
	SubscriptionMonthlyDiscountWebComponent,
	SubscriptionMonthlyWebComponent,
	ShootsAppointmentsBlockComponent,
	EventTypeRowComponent,
	AddRoundBtnComponent,
	SimplePaginationComponent,
	RecentLeadsBlockComponent,
	DeleteLeadModalComponent,
	UserMenuComponent,
	DeleteLeadModalComponent,
	DragAndDropBlockComponent,
	GraphsBlockComponent,
	UpcomingPaymentsBlockComponent,
	RecordPaymentModalComponent,
	WriteOffModalComponent,
	JobTaskBlockComponent,
	DeleteJobModalComponent,
	GraphsBlockComponent,
	SnDateRangePickerComponent,
	SnDatePickerComponent,
	UploadComponent,
	SnTinyEditorWebComponent,
	JobFilesModalComponent,
	SnTinyEditorWebComponent,
	QuoteUpdateComponent,
	MainShootDateComponent,
	QuoteJobInfoComponent,
	QuoteClientInfoComponent,
	QuoteCreatePackageComponent,
	PaymentScheduleComponent,
	QuoteContractAndQuestionComponent,
	UploadComponent,
	SnTinyEditorWebComponent,
	JobFilesModalComponent,
	QuoteCreatePackageComponent,
	QuoteViewComponent,
	PrintBtnComponent,
	ModalDeleteQuoteComponent,
	QuoteInfoComponent,
	QuoteFromInfoComponent,
	ModalSendQuoteComponent,
	PackageInfoPanelComponent,
	PriceTagComponent,
	SnTinyEditorWebComponent,
	QuoteSummaryBlockComponent,
	PackagesProductBlockComponent,
	PackagesBlockComponent,
	ProductBlockComponent,
	UpdatePackageProductModalComponent,
	ProductDetailsModalComponent,
	AddonsTableComponent,
	MainShootDateComponent,
	AutocompleteEmailInputComponent,
	AddNewElementBtnComponent,
	AddQuoteTypeModalComponent,
	InvoiceUpdateDnd,
	QuoteViewFixedComponent,
	ProductPackageTableComponent,
	QuoteAssignmentPanelComponent,
	ReSyncBtnComponent,
	QuoteAssignmentPanelComponent,
	InvoiceViewComponent,
	InvoiceInfoTableComponent,
	InvoicePaymentsScheduleTable,
	PreviewBtnComponent,
	CopyToXeroBtnComponent,
	CopyToQbBtnComponent,
	DeleteInvoiceModalComponent,
	InvoicePaymentActionButtons,
	SavePdfBtnComponent,
	QuoteAssignmentPanelComponent,
	ReSyncBtnComponent,
	InvoicePaymentsScheduleTable,
	SnQuillViewComponent,
	ShowMoreContentComponent,
	DiscountCreateBlockComponent,
	DiscountViewBlockComponent,
	InvoiceClientInfoComponent,
	InvoiceContractQuestionComponent,
	InvoiceJobInfoComponent,
	InvoiceMainInfoComponent,
	InvoicePaymentScheduleComponent,
	InvoiceSummaryComponent,
	InvoiceUpdateComponent,
	DiscountViewBlockComponent,
	ModalMakeInvoiceComponent,
	MarkQuoteAsAcceptedModal,
	DiscountViewBlockComponent,
	ShootProofViewBlockComponent,
	ShootProofDeleteGalleryModal,
	AddShootProofGalleryModal,
	CreateNewShootProofGalleryModal,
	SelectExistingShootProofGalleryModal,
	DeleteConfirmationModal,
	MarkQuoteAsAcceptedModal,
	InvoicePaymentsScheduleTable,
	SnQuillViewComponent,
	ShowMoreContentComponent,
	DiscountCreateBlockComponent,
	DiscountViewBlockComponent,
	InvoicesViewBlockComponent,
	ShootproofInvoicesBlockComponent,
	CopyInvoiceToQuickBooksModal,
	PaymentsOverviewComponent,
	ContactFormSectionComponent,
	TemplateListComponent,
	SettingSectionHeaderComponent,
	SettingSectionDescriptionComponent,
	SettingsAddBtnComponent,
	DeleteItemModalComponent
];



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=nfw9yna8xro!./web/modern/components/modernComponents.ts